<template lang="">
  <div>
    <section>
      <div
        class="w-full mx-auto max-w-7xl 2xl:max-w-screen-2xl mt-[3rem] md:mt-[3rem] mb-[3rem]"
      >
        <div
          class="flex flex-col lg:flex-row justify-center items-center gap-3 lg:gap-0 p-5 md:p-0 2xl:p-[2rem]"
        >
          <picture>
            <source
              media="(min-width:650px)"
              srcset="@/assets/home/Jain-University1.webp"
              alt="jain universtiy image"
              decoding="async"         
            />
            <img
              src="@/assets/home/Jain-University-2.webp"
              alt="jain universtiy image"
              decoding="async"
              class="w-[390px] h-[480px] lg:w-[520px] lg:h-[520px] mx-auto rounded-[25px] md:rounded-[40px] shadow-xl"
            />
          </picture>

          <div
            class="lg:w-[55%] md:flex md:flex-col md:justify-center md:items-center lg:px-8"
          >
            <h2
              class="text-4xl text-black font-bold md:text-left pt-4 md:pt-0 md:mt-4 lg:mt-0 lg:self-start"
            >Who We Are
            </h2>
            <p
              class="text-center lg:text-justify text-[16px] lg:text-[18px] pt-4 font-medium md:px-[5rem] lg:px-2 lg:pr-5"
            >JAIN Online is a part of the NAAC A++ graded JAIN (Deemed-to-be University), offering UGC-Entitled online degree programs intending to empower learners by providing the latest knowledge and skills to help them effectively shape their professional paths.
            </p>
            <p
              class="text-center lg:text-justify text-[16px] lg:text-[18px] mt-[1rem] font-medium md:px-[5rem] lg:px-2 lg:pr-5"
            >Leveraging over 30 years of educational expertise and advanced tech-enabled learning methodologies, we prioritize academic as well as personal growth, facilitating well-rounded development. With a team of skilled academics and digital innovators, our flexible online platform enables learners to learn from anywhere and at any time.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "WhoView",
};
</script>
<style lang=""></style>
